// @flow
import React from 'react';
import { Select, SelectTypes } from 'common/components/core/select/Select';
import { memoizedImmutable } from 'common/utils/Memoizer';
import theme from './IntelliSortFeedbackZoneSelector.scss';

import intelliSortIds from 'common/tests/intellisort/intelliSortIds.json';

export class IntelliSortFeedbackZoneSelector extends React.PureComponent {
    handleonChange = newValue => {
        const { orderId, feedbackStatus, onChange } = this.props;
        const value = newValue ? newValue.value : '';
        return onChange(true, true, orderId, feedbackStatus, value, 'routeId');
    };

    @memoizedImmutable()
    getZoneIdsOptions(allowedRouteIds: List<string>) {
        const options = [];
        if (allowedRouteIds) {
            allowedRouteIds.forEach(zonId => {
                options.push({
                    value: zonId,
                    label: zonId
                });
            });
        }
        return options;
    }

    render() {
        const {
            routeId,
            allowedRouteIds,
            isFeedbackActive,
            placeholder
        } = this.props;
        const options = this.getZoneIdsOptions(allowedRouteIds);

        return (
            <Select
                placeholder={placeholder}
                isClearable
                selectType={SelectTypes.Outline}
                options={options}
                value={routeId}
                onChange={this.handleonChange}
                className={theme.zoneIdSelector}
                theme={theme}
                disabled={!isFeedbackActive}
                testId={intelliSortIds.expectedZone}
            />
        );
    }
}
